// Three signals arrive on different clocks and rates. The module aligns them
// on one timeline, windows them, and emits one computed conclusion.

const ROWS = [
  { y: 80, label: "pressure", color: "trace-cyan", ticks: [0, 62, 124, 186, 248], d: "M0 0c20-14 40 10 60-2s40-16 60 2 40 12 60-6 40-10 60 4 30 6 40 0" },
  { y: 170, label: "current", color: "trace-amber", ticks: [18, 96, 174, 252], d: "M0 4h30l8-18 10 26 8-12h50l6 10 10-20 8 10h60l8-16 10 24 8-8h54" },
  { y: 260, label: "vibration", color: "trace-steel", ticks: [0, 31, 62, 93, 124, 155, 186, 217, 248, 279], d: "M0 0l8 -8 8 12 8 -14 8 16 8 -12 8 8 8 -10 8 14 8 -14 8 10 8 -8 8 12 8 -14 8 10 8 -6 8 8 8 -10 8 12 8 -12 8 8 8 -6 8 8 8 -10 8 12 8 -10 8 6 8 -8 8 10 8 -8 8 6 8 -6 8 6 8 -8 8 8 8 -2" },
];

export function SyncGraphic() {
  return (
    <svg
      className="mk-svg"
      viewBox="0 0 900 360"
      role="img"
      aria-label="Three signals sampled on different clocks are aligned to one timeline inside the module and combined into a single computed output."
    >
      <text x="20" y="34" className="svg-k">Raw · different clocks</text>
      <text x="470" y="34" className="svg-k">Synced · one grid</text>
      <text x="720" y="34" className="svg-k">Computed</text>

      {/* sync band */}
      <rect x="392" y="46" width="60" height="280" rx="2" fill="rgba(79,216,236,.08)" stroke="var(--mk-cyan)" strokeDasharray="4 6" />
      <text x="422" y="190" textAnchor="middle" className="svg-l" style={{ fontSize: 12, letterSpacing: ".14em" }} transform="rotate(-90 422 190)">SYNC</text>

      {ROWS.map((r, i) => (
        <g key={r.label}>
          {/* left: raw with irregular ticks */}
          <text x="20" y={r.y + 4} className="svg-s" style={{ fill: "var(--mk-fg)" }}>{r.label}</text>
          <line x1="110" x2="380" y1={r.y} y2={r.y} stroke="rgba(255,255,255,.08)" />
          {r.ticks.map((t) => (
            <line key={t} x1={110 + t} x2={110 + t} y1={r.y - 8} y2={r.y + 8} stroke="rgba(255,255,255,.28)" />
          ))}
          <g transform={`translate(110 ${r.y})`}>
            <path d={r.d} className={`trace ${r.color} draw`} pathLength={1} style={{ ["--delay" as string]: `${i * 0.2}s` }} />
          </g>

          {/* right: aligned to shared ticks; the grid advances one sample at a time */}
          <line x1="470" x2="700" y1={r.y} y2={r.y} stroke="rgba(255,255,255,.08)" />
          <g clipPath="url(#sync-grid-clip)">
            <g className="grid-scroll">
              {[-46, 0, 46, 92, 138, 184, 230].map((t) => (
                <circle key={t} cx={470 + t} cy={r.y} r="4" className={r.color.replace("trace-", "svg-")} style={{ fill: r.color === "trace-steel" ? "var(--mk-steel)" : undefined }} />
              ))}
            </g>
          </g>
        </g>
      ))}

      {/* shared clock */}
      <defs>
        <clipPath id="sync-grid-clip"><rect x="466" y="52" width="238" height="248" /></clipPath>
      </defs>
      <g clipPath="url(#sync-grid-clip)">
        <g className="grid-scroll">
          {[-46, 0, 46, 92, 138, 184, 230].map((t) => (
            <line key={t} x1={470 + t} x2={470 + t} y1="52" y2="300" stroke="rgba(79,216,236,.18)" />
          ))}
        </g>
      </g>
      <rect x="470" y="52" width="230" height="248" rx="2" fill="none" stroke="rgba(79,216,236,.35)" strokeDasharray="5 6" />
      <text x="585" y="342" textAnchor="middle" className="svg-s" style={{ fontSize: 12 }}>30 s moving window · one sample grid</text>

      {/* arrows */}
      <path d="M380 170h12" stroke="var(--mk-amber)" strokeWidth="2" />
      <path d="M700 170h14" stroke="var(--mk-green)" strokeWidth="2" />
      <path d="M709 165l6 5-6 5" fill="none" stroke="var(--mk-green)" strokeWidth="2" />

      {/* computed output */}
      <g transform="translate(720 60)">
        <rect width="160" height="220" rx="2" fill="rgba(98,214,156,.06)" stroke="var(--mk-green)" />
        <text x="16" y="30" className="svg-s" style={{ fontSize: 12 }}>pump_health</text>
        <text x="16" y="74" className="svg-l" style={{ fontSize: 40, fontWeight: 600, letterSpacing: "-.03em" }}>98.00</text>
        <text x="16" y="98" className="svg-s" style={{ fontSize: 12 }}>score · last 30 s</text>
        <g transform="translate(16 130)">
          <path d="M0 40c14-20 26-30 40-28s24 22 38 18 22-26 50-30" className="trace trace-green draw" pathLength={1} style={{ ["--delay" as string]: "0.9s" }} />
        </g>
        <circle cx="140" cy="140" r="5" className="svg-green pulse" />
        <text x="16" y="200" className="svg-s" style={{ fontSize: 12 }}>→ written as a tag</text>
      </g>
    </svg>
  );
}
